export default __webpack_public_path__ + "static/media/co2logic-footer.5b3da476.svg";